import type { TComponent } from 'utils/types/component';

import {
    type IPaymentInvoice,
    PAYMENT_INVOICE_STATUS_INVOICE,
} from 'models/Invoice/Payment';

import styles from './AmountCell.module.scss';

interface IAmountCellProps {
    record: IPaymentInvoice;
}

export const AmountCell: TComponent<IAmountCellProps> = (props) => {
    const { record } = props;

    const hasPayback =
        record.status === PAYMENT_INVOICE_STATUS_INVOICE.CHARGEBACK ||
        record.status === PAYMENT_INVOICE_STATUS_INVOICE.REFUND;

    const paybackAmount = record.chargebackAmount || record.refundAmount || 0;
    const amount = parseFloat(
        (
            record.amount +
            Number(record.surchargeAmount) -
            paybackAmount
        ).toFixed(2),
    );

    return hasPayback ? (
        <div className={styles.amount}>
            <span className={styles.green}>{amount}</span>
            <span className={styles.red}>{paybackAmount}</span>
        </div>
    ) : (
        <span>{record.amount}</span>
    );
};
